export const APP_ROUTES = {
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  DASHBOARD: '/dashboard',
  HOME: '/',
  CHAT: '/chat',
};
